import React from "react";
import PropTypes from "prop-types";
import {
    Button,
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";

import ProductTypePill from "../../../../components/ProductTypePill";
import getProductTypeValues from "../../../../utilities/getProductTypeValues";

function DiscountCodeProductListItem({ product, onClickRemove, disabled }) {
    return (
        <div className="card mb-2">
            <div className="card-body d-flex align-items-center py-2 px-3">
                <div className="flex-grow-1">
                    <span className="font-weight-bold mr-2">{ product.name }</span>
                    { getProductTypeValues(product).length > 0 && (
                        <small>
                            <ProductTypePill product={ product }/>
                        </small>
                    )}
                </div>
                { onClickRemove && (
                    <OverlayTrigger overlay={
                        <Tooltip id={ `remove-${product.id}` }>Product verwijderen</Tooltip>
                    }>
                        <Button
                            variant="link"
                            className="text-danger p-0 ml-2"
                            onClick={ () => onClickRemove(product) }
                            disabled={ disabled }
                        >
                            <i className="fas fa-trash"/>
                        </Button>
                    </OverlayTrigger>
                )}
            </div>
        </div>
    )
}
DiscountCodeProductListItem.propTypes = {
    product: PropTypes.object.isRequired,
    onClickRemove: PropTypes.func,
    disabled: PropTypes.bool
}

export default React.memo(DiscountCodeProductListItem);
